import React, { useState } from 'react'
import I18n from 'lib/i18n'

export default function SlideFour ({ slideIndex }) {
  const style = slideIndex === 4 ? { display: 'flex', justifyContent: 'space-between' } : { display: 'none' }
  const [expand, setExpand] = useState(false)

  return (
    <div className='slide.slide-4' style={style}>
      <div className='left-par not-responsive'>
        <div className='not-responsive-inline-block' style={{ maxWidth: 410, margin: '0 auto' }}>
          <img
            className='lazyload'
            data-src='/assets/pages/how1/account.png'
            data-retina='/assets/pages/how1/account@2x.png'
            style={{ maxWidth: '100%', width: 'auto !important', height: 'auto !important' }}
            alt=''
          />
        </div>
      </div>
      <div className='right-part'>
        <h3 dangerouslySetInnerHTML={{ __html: I18n.t('pages.how1.students_4_title') }} />
        <div className='only-responsive-inline-block' style={{ maxWidth: 410, margin: '0 auto', marginBottom: 10 }}>
          <img
            className='lazyload'
            data-src='/assets/pages/how1/account.png'
            data-retina='/assets/pages/how1/account@2x.png'
            style={{ maxWidth: '100%', width: 'auto !important', height: 'auto !important' }}
            alt=''
          />
        </div>
        <div dangerouslySetInnerHTML={{ __html: I18n.t('pages.how1.students_4') }} />
        {I18n.locale === 'fr' && (
          <>
            <p
              className='learn-more-link'
              onClick={() => setExpand(true)}
              style={{ display: expand ? 'none' : 'block' }}
            >
              <a href='#'>{I18n.t('pages.how1.link_more')}</a>
            </p>
            <div
              style={{ display: expand ? 'block' : 'none' }}
              className='learn-more-section'
              dangerouslySetInnerHTML={{ __html: I18n.t('pages.how1.students_4_more') }}
            />
          </>
        )}
      </div>
    </div>
  )
}
